export const menuApiUrlPrefix = '/v1/menu';
export const loyaltyApiUrlPrefix = '/loyalty';
